// 对于不同页面体系的路由，需要管理不同的缓存策略

export const includesEnterprise = [
	'single_template_home_root',
	'single_template_home',
	'single_menu_frame',
	'single_component_frame_v1',
	'single_component_frame_sub',
	'single_component_frame',

	'multi_template_home_root',
	'multi_template_home',
	'multi_menu_frame',
	'multi_component_frame_sub',
	'multi_component_frame'
];
